import { Component, OnInit } from '@angular/core';
import { UtilService } from '../util/util.service';

@Component({
  selector: 'app-register-services',
  templateUrl: './register-services.component.html',
  styleUrls: ['./register-services.component.css'],
})
export class RegisterServicesComponent implements OnInit {
  constructor(private utilService: UtilService) {}

  ngOnInit() {}

  print_command() {
    let data = {
      order_id: 'HJDVzaqj7r1610445284',
      type: 1,
      counter_id: '',
      itr: 1,
    };
    this.utilService.openReceiptWindow(data, 10000);
  }

  cash_drawer() {
    let data = {
      printerName: 'CASHIER',
      numCode: '[27,112,0,25,250]',
    };
    this.utilService.openCashDrawerWindow(data, 10000);
  }
}
